// src/app/services/email.service.ts
//
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { EmailRequest } from "../model/email.model";
import { Observable } from "rxjs";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class TestEmailService {
  private apiUrl = environment.apiUrl;
  private mailUrl = environment.mailApiUrl;

  constructor(private http: HttpClient) {}

  sendTestEmail(email: EmailRequest) {
    return this.http.post(`${this.apiUrl}/send-email`, email);
  }

  getMailServerReadyStatus(): Observable<any> {
    return this.http.get(`${this.mailUrl}/healthz/ready`);
  }
}
